import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper-bundle.css";
import { separate } from "../../Seprate/Seprate";
const NewDiscount = ({ data ,suplierId}) => {
  const points = {
    350: {
      slidesPerView: 1.5,
    },
    450: {
      slidesPerView: 2,
    },
    550: {
      slidesPerView: 2.5,
    },
    670: {
      slidesPerView: 3,
    },
    775: {
      slidesPerView: 3.5,
    },
    906: {
      slidesPerView: 4,
    },
    1150: {
      slidesPerView: 4.5,
    },
    1400: {
      slidesPerView: 6,
    },
  };
  return (
    <>
      <Swiper style={{width:"100%",height:"68%"}} spaceBetween={20} breakpoints={points} dir="rtl">
        {data.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className={"eachSlide"}>
                <Link to={`/product/${item.id}/${suplierId}/`}>
                  <div className={"picHolder"}>
                    <img
                      src={`//cdn.barest.ir/product/m/${item.id}.jpg`}
                      alt="تخفیفات"
                    />
                  </div>
                </Link>
                <div className={"information"}>
                  <h4 className={"name"}>{item.name}</h4>
                  <div className={"priceHolder"}>
                    <span className={"offprice"}>
                      {separate(item.off_price)} تومان
                    </span>
                    <span className={"price"}>
                      {separate(item.price)} تومان
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default NewDiscount;
